import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { IdInterface, ModelInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('PivotFund')
class PivotFund {
    @JsonProperty('ProductIdentifier', IdAdapter, true)
    private _id: IdInterface = undefined;

    @JsonProperty('ProductCode', IdAdapter, true)
    private _code: IdInterface = undefined;

    @JsonProperty('ProductISIN', StringAdapter, true)
    private _isin: string = undefined;

    @JsonProperty('ProductName', StringAdapter, true)
    private _name: string = undefined;

    get id(): IdInterface {
        return this._id;
    }

    get code(): IdInterface {
        return this._code;
    }

    get isin(): string {
        return this._isin;
    }

    get name(): string {
        return this._name;
    }
}

@JsonObject('Model')
export class Model implements ModelInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: IdInterface = undefined;

    @JsonProperty('Name', StringAdapter, true)
    private _name: string = undefined;

    @JsonProperty('MinimumInvest', Number, true)
    private _minimumInvest: number = undefined;

    @JsonProperty('PivotFund', PivotFund, true)
    private _pivotFund: PivotFund = undefined;

    get id(): IdInterface {
        return this._id;
    }

    get name(): string {
        return this._name;
    }

    get minimumInvest(): number {
        return this._minimumInvest;
    }

    get pivotFund(): PivotFund {
        return this._pivotFund;
    }
}
